import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "user-interact-amount" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("span", { class: "visually-hidden" }, "Gemochte Benutzer", -1);
const _hoisted_3 = { class: "user-interact-like-btn-users" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("span", { class: "visually-hidden" }, "Schließen", -1);
const _hoisted_5 = {
    class: "spinner-border text-primary",
    role: "status"
};
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "visually-hidden" }, "Loading", -1);
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = { class: "list-unstyled user-interact-like-btn-users-list" };
const _hoisted_9 = { key: 0 };
export function render(_ctx, _cache) {
    const _component_users = _resolveComponent("users");
    const _component_hearth_full = _resolveComponent("hearth-full");
    const _component_hearth_empty = _resolveComponent("hearth-empty");
    const _component_close = _resolveComponent("close");
    const _component_el_popover = _resolveComponent("el-popover");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([`user-interact-like`, { 'user-interact-like--liked': _ctx.isLiked }])
    }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.analyticsObject.likesCount ? _ctx.analyticsObject.likesCount : '') + " " + _toDisplayString(_ctx.analyticsObject.countLikes ? _ctx.analyticsObject.countLikes : '') + " " + _toDisplayString(_ctx.analytics.likesCount ? _ctx.analytics.likesCount : ''), 1),
        (_ctx.analytics.likesCount > 0 ||
            _ctx.analyticsObject.countLikes > 0 ||
            _ctx.analyticsObject.likesCount > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn user-interact-like-btn p-0 d-lg-none me-half",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.likeBtnHover(true)), ["prevent"]))
            }, [
                _createVNode(_component_users),
                _hoisted_2
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_el_popover, {
            width: 220,
            visible: _ctx.isVisible,
            "onUpdate:visible": _cache[5] || (_cache[5] = ($event) => (_ctx.isVisible = $event)),
            trigger: "hover",
            placement: "bottom-end",
            "popper-class": "user-interact-popper",
            disabled: _ctx.analytics.likesCount === 0 || _ctx.analyticsObject.countLikes === 0 || _ctx.analyticsObject.likesCount === 0
        }, {
            reference: _withCtx(() => [
                _createElementVNode("button", {
                    type: "button",
                    class: "btn user-interact-like-btn p-0",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.likeBtn && _ctx.likeBtn(...args)), ["prevent"])),
                    onMouseenter: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.likeBtnHover && _ctx.likeBtnHover(...args)))
                }, [
                    _createVNode(_component_hearth_full),
                    _createVNode(_component_hearth_empty)
                ], 32)
            ]),
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "btn user-interact-like-btn user-interact-like-btn-users-close p-0 d-lg-none me-half",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (this.isVisible = false), ["prevent"]))
                    }, [
                        _createVNode(_component_close),
                        _hoisted_4
                    ]),
                    _createVNode(_Transition, { name: "fade" }, {
                        default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_5, _hoisted_7, 512), [
                                [_vShow, _ctx.isLoading]
                            ])
                        ]),
                        _: 1
                    }),
                    _createElementVNode("ul", _hoisted_8, [
                        _createVNode(_TransitionGroup, { name: "arrange" }, {
                            default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.isLoadedAllLikedUsers ? _ctx.likedUsers : _ctx.likedUsers.slice(0, this.size), (user, index) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: 'list-item-' + index,
                                        class: "user-interact-like-btn-users-item"
                                    }, [
                                        (user.user && user.user.loginNameCut)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(user.user.loginNameCut), 1))
                                            : _createCommentVNode("", true)
                                    ]));
                                }), 128))
                            ]),
                            _: 1
                        }),
                        (!_ctx.isLoadedAllLikedUsers && _ctx.likedUsers.length > this.size)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                onClick: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.loadAllLikedUsers && _ctx.loadAllLikedUsers(...args))),
                                class: "user-interact-like-btn-users-item user-interact-like-btn-users-item--more"
                            }, _toDisplayString(_ctx.likedUsers.length - this.size) + " weiteren gefällt dieser Beitrag ", 1))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]),
            _: 1
        }, 8, ["visible", "disabled"])
    ], 2));
}
